<template>
  <!-- 发送验证码组件 -->
  <div class="wrap_">
    <img
      v-if="showIcon && loginType"
      class="img_"
      :style="isBig ? style : ''"
      src="~@/assets/image/common/9.png"
      alt="img"
    />
    <img
      v-else-if="showIcon"
      class="img_"
      :style="isBig ? style : ''"
      src="~@/assets/image/common/key.png"
    />
    <cube-input
      class="logStyle"
      :type="loginType ? 'password' : 'text'"
      :placeholder="
        placeholder
          ? placeholder
          : loginType
          ? $t('login.inputPassword')
          : $t('login.inputCode')
      "
      :value="value"
      @change="handleChange"
      :maxlength="loginType ? 20 : 6"
    ></cube-input>
    <button @click="handleSendCode" v-if="!loginType" class="btn_plain_">
      {{
        hasSend ? $t('login.btn_resend') + countTime : $t('login.btn_sendCode')
      }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    // 默认文字
    placeholder: {
      type: String,
      default: ''
    },
    // 是否大号input
    isBig: {
      type: Boolean,
      default: false
    },
    // 是否显示图标
    showIcon: {
      type: Boolean,
      default: true
    },
    // 登录类型
    loginType: {
      type: Number,
      default: 0
    },
    // 输入值
    value: {
      type: String,
      default: ''
    },
    // 手机号
    mobile: {
      type: String,
      default: ''
    },
    // 输入框类型'text' or 'password'
    type: {
      type: Number,
      default: 1
    },
    // 手机号区域
    area: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      style: ' width: 15px; height: auto; left: 15px; top: 15px',
      hasSend: false,
      countTime: 0
    }
  },
  methods: {
    // 输入验证码
    handleChange(e) {
      this.$emit('input', e.target.value)
    },
    // 发送验证码
    handleSendCode() {
      if (!this.mobile) {
        this.$toast('请输入手机号', 'Please enter phone number')
        return
      }
      if (!/\d{8}/.test(this.mobile)) {
        this.$toast(this.$t('login.errorPhone'))
        return
      }
      if (this.countTime > 1) {
        return
      }
      this.$apis
        .getVerificationCode({
          mobile: this.area + this.mobile,
          smsFlag: this.type
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$toast(res.data.msg)
            return
          }
          if (this.$i18n.locale == 'zh-cn') {
            this.$toast('验证码已发送')
          } else {
            this.$toast('Verification code sent')
          }
          this.startCountTime()
        })
    },
    // 倒计时
    startCountTime() {
      this.countTime = 60
      this.hasSend = true
      let si = setInterval(() => {
        this.countTime = --this.countTime
        if (this.countTime == 1) {
          this.hasSend = false
          clearInterval(si)
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap_ {
  position: relative;

  .btn_plain_ {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: inherit;
    border: none;
    min-width: 95px;
    overflow: hidden;
  }
}
.img_ {
  height: 13px;
  width: auto;
  position: absolute;
  left: 10px;
  top: 19px;
  z-index: 1;
}
</style>
